module.exports = __webpack_public_path__ + "img/P32920580Pcamera.ed86ba8a.jpg";